import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Label from '../label/label';
import { doA11yValidation } from 'zengenti-forms-package/utils/validate-utils';
import { makeSelectFormValidationSent } from 'zengenti-forms-package/redux/selectors';
import { useSelector } from 'react-redux'
import { CharacterLimit } from 'zengenti-forms-package/components/charaterlimit';

const Textarea = ({
  className,
  field,
  formId,
  id,
  label,
  type,
  setValue,
  validations,
  defaultValue,
  defaultLanguage,
  placeholder,
  onValidateField,
  useDefaultTheme,
}) => {
  const [showCharLimit, setShowCharLimit] = useState(false);
  const isRequired = validations && validations.required ? true : false;
  const placeholderText =
    placeholder &&
    placeholder.properties &&
    placeholder.properties.placeholderText &&
    placeholder.properties.placeholderText[defaultLanguage];
  const defaultValueText = defaultValue ? defaultValue[defaultLanguage] : null;

  const [a11yInvalid, setA11yInvalid] = useState('');
  const [_, setTextareaValue] = useState(defaultValueText || ''); 
  const selectFormValidationSent = makeSelectFormValidationSent(formId);
  const formValidationSent = useSelector(selectFormValidationSent);
  useEffect(() => {
    if (formValidationSent) setA11yInvalid(doA11yValidation(_, field, true));
  }, [formValidationSent])

  return (
    <div className={className}>
      <Label
        id={id}
        label={label}
        isRequired={isRequired}
        className="text-area__label"
      />
      {showCharLimit && (
        <CharacterLimit
          value={defaultValue}
          validations={validations}
          defaultLanguage={defaultLanguage}
          useDefaultTheme={useDefaultTheme}
        />
      )}
      <div className="text-area__input--wrapper" style={{ position: 'relative'}}>
        <textarea
          className='text-area__input'
          type={type}
          id={id}
          defaultValue={defaultValueText}
          placeholder={placeholderText}
          aria-invalid={a11yInvalid}
          onChange={e => {
            setTextareaValue(e.target.value)
            setValue(formId, id, e.target.value);
          }}
          onBlur={e => {
            onValidateField(formId, id, e.target.value);
            setShowCharLimit(false);
            setA11yInvalid(doA11yValidation(e.target.value, field, formValidationSent))
          }}
          onFocus={() => { 
            setShowCharLimit(true);
          }}
        />
        {a11yInvalid == 'true' && (
          <svg className="svg" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true" role="presentation" width="16" height="16" fill="none"><path fill="#333" d="M12.2 3.807a.664.664 0 0 0-.94 0L8 7.06 4.74 3.8a.665.665 0 0 0-.94.94L7.06 8 3.8 11.26a.664.664 0 1 0 .94.94L8 8.94l3.26 3.26a.665.665 0 0 0 .94-.94L8.94 8l3.26-3.26a.668.668 0 0 0 0-.933Z"/></svg>
        )}
        {a11yInvalid == 'false' && (
          <svg className="svg" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true" role="presentation" width="16" height="16" fill="none"><path fill="#333" d="m2 8 4.418 4.667L14 4.659l-1.246-1.326-6.336 6.692-3.18-3.332L2 8Z"/></svg>
        )}
      </div>
    </div>
  );
};

Textarea.propTypes = {
  className: PropTypes.string,
  field: PropTypes.any,
  formId: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  setValue: PropTypes.func,
  validations: PropTypes.object,
  defaultValue: PropTypes.object,
  defaultLanguage: PropTypes.string,
  placeholder: PropTypes.object,
  onValidateField: PropTypes.func,
  useDefaultTheme: PropTypes.bool,
  errors: PropTypes.array,
};

export default Textarea;
